<div class="list-header mb-1" [ngStyle]="UIUtilityService.getHeaderStyle()">
	<a [routerLink]="group.path" routerLinkActive="active" class="cursor-pointer font-sidebar-title" (click)="dismissSidebarNav()"> {{ group.title | translate }}</a>
</div>
<ul>
	@for(activity of group.activities; track activity.name) {
		<app-base-sidebar-activity [activity]="activity" (click)="dismissSidebarNav()"></app-base-sidebar-activity>
	}
</ul>